import { VercelEdgeConfigInitDataProvider } from 'hypertune'
import { createClient } from '@vercel/edge-config'
import { createSourceForServerOnly } from '../../generated/hypertune'
import { getHypertuneUserId, setHypertuneUserId } from '../utils/hypertune'
import { generateAnonymousUserId } from '../utils/storage'

const hypertuneSource = createSourceForServerOnly({
  token: process.env.NEXT_PUBLIC_HYPERTUNE_TOKEN!,
  initDataProvider:
    process.env.EDGE_CONFIG && process.env.EDGE_CONFIG_HYPERTUNE_ITEM_KEY
      ? new VercelEdgeConfigInitDataProvider({
          edgeConfigClient: createClient(process.env.EDGE_CONFIG),
          itemKey: process.env.EDGE_CONFIG_HYPERTUNE_ITEM_KEY,
        })
      : undefined,
})

export async function getHypertune() {
  await hypertuneSource.initIfNeeded() // Check for flag updates

  // Ensure we have a user ID
  let userId = getHypertuneUserId()
  if (!userId) {
    // Generate a new anonymous user ID if none exists
    userId = generateAnonymousUserId()
    setHypertuneUserId(userId)
  }

  return hypertuneSource.root({
    args: {
      context: {
        environment: process.env.NODE_ENV,
        user: { id: userId },
      },
    },
  })
}
